import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MoodService } from 'src/app/services/mood.service';
import { Moods, MoodsDefaultvalues } from '../moods';
import { TranslationService } from 'src/app/services/translation.service';
import { ParticipantThemeService } from 'src/app/services/participant-theme.service';

@Component({
    selector: 'app-mood-modal-data',
    templateUrl: './mood-modal-data.component.html',
    styleUrls: ['./mood-modal-data.component.scss'],
    standalone: false
})
export class MoodModalDataComponent {

  moods: any[] = [];
  selectedMood: Moods = MoodsDefaultvalues();
  selectedMoodId: number = 0;
  showDescription: boolean = false;
  translations: any;
  participantClassByRole: string = '';

  constructor(public dialogRef: MatDialogRef<MoodModalDataComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _moodservice: MoodService,
    private dialog: MatDialog,
    private translationservice: TranslationService,
    private themeService: ParticipantThemeService
  ) { }

  ngOnInit(): void {
    this._moodservice.getAllMoods().subscribe({
      next: (data) => {
        this.moods = data
      }
    })

    this.translationservice.getTranslation().subscribe({
      next: (translations) => {
        this.translations = translations
      }
    })

    this.themeService.setParticipantTheme();
    this.participantClassByRole = this.themeService.participantClassByRole;
  }

  getMoodValue(mood: any) {
    this.selectedMood.mood = mood.id
    this.selectedMoodId = mood.id
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
